// angular
//     .module('HeroPRO')
//     .factory("LeadFactory", leadFactory);

import _ from 'lodash';

/* @ngInject */
export default function leadFactory($http, HPConfig, $q, UserData, HPAppDetailTypes) {
    const leadData = {};

    return {
        getLeadData,
        setLeadData,
        getLeadMessages,
    };

    function setLeadData(newLeadData) {
        leadData[newLeadData.PreQualID] = newLeadData;
    }

    function getLeadData(prequalId) {
        if (_.has(leadData, prequalId)) {
            // Prequal is in the cache and the data is complete
            const deferred = $q.defer();
            deferred.resolve(leadData[prequalId]);
            return deferred.promise;
        }
        // Prequal is not in the cache
        return $q((resolve) => {
            requestLeadData(prequalId).then((response) => {
                setLeadData(response.data.Data);
                resolve(leadData[prequalId]);
            });
        });
    }

    function getLeadMessages(prequalId, organizationId) {
        return $q((resolve) => {
            const message = {
                show: false,
                header: '',
                text: '',
            };

            // prequalId comes through as string for lead detail
            if (!_.isEmpty(prequalId) && _.isString(prequalId)) {
                prequalId = parseInt(prequalId);
            }
            // if somehow there is no prequalId don't show any messaging
            if (!_.isNumber(prequalId) || prequalId < 1) {
                resolve(message);
            } else {
                getOrgTermSets(organizationId).then((orgTermSets) => {
                    checkForMatterhorn(prequalId, orgTermSets, message).then((response) => {
                        // resolve(response); // response is message returned
                        resolve(); // just resolve with the false message for now
                    });
                });
            }
        });
    }

    function checkForMatterhorn(prequalId, orgTermSets, message) {
        return $q((resolve) => {
            getLeadData(prequalId).then((leadDataResponse) => {
                // Check if the organization has a buydown rate
                const buydownTermSets = _.findWhere(orgTermSets, {
                    TermSetTypeId: HPAppDetailTypes.TermSetTypes.BuyDown,
                });
                if (buydownTermSets !== undefined) {
                    // Check if the property address belongs to a program that has mattherhorn term set rates
                    if (_.findWhere(orgTermSets, {
                        ProgramId: leadDataResponse.ProgramId,
                    }) !== undefined) {
                        setMatterhornMessage(message);
                    } else {
                        setNonMatterhorn(message);
                    }
                }
                resolve(message);
            });
        });
    }

    function setNonMatterhorn(message) {
        message.header = 'Standard HERO rates apply on this home.';
        message.text = 'For rate details, contact your account manager.';
        message.class = 'lead-message warn';
        message.show = true;
    }

    function setMatterhornMessage(message) {
        message.header = 'Good News! Promotional rates apply on this home.';
        message.text = 'For rate details, contact your account manager.';
        message.class = 'lead-message good';
        message.show = true;
    }

    // ////////
    // private functions
    // ////////

    function getOrgTermSets(orgId) {
        return $q((resolve) => {
            if (_.isNumber(orgId)) { // RA Employee is running KBYG for a CO, get CO Org TermSets
                $http({
                    url: `${HPConfig.heroProApi}Organization/TermSets`,
                    method: 'GET',
                    params: {
                        organizationId: orgId,
                    },
                }).then((response) => {
                    resolve(response.data.Data);
                });
            } else { // CO is running a KBYG, get their term sets
                UserData.getCurrentLocation().then((locationDataResponse) => {
                    resolve(locationDataResponse.OrganizationTermSets);
                });
            }
        });
    }

    function requestLeadData(prequalId) {
        return $http({
            url: `${HPConfig.heroProApi}KBYG`,
            method: 'GET',
            cache: true,
            params: {
                PreQualId: prequalId,
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/lead/leadFactory.js